import { FCC } from "@/types/common";
import { TGetRSODto } from "@/api/services/main/rso/dtos/get-rso.dto";
import { Grid, Stack, Typography } from "@mui/material";
import { MenuNavigate } from "@/components/elements/MenuNavigate";
import { RsoBasicInfoSection } from "@/features/rso/components/rso-detail/RsoBasicInfoSection";
import { RsoVisaLinkSection } from "@/features/rso/components/rso-detail/RsoVisaLinkSection";
import { RsoContractInfoSection } from "@/features/rso/components/rso-detail/RsoContractInfoSection";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { text } from "@/theme/colors";
import { IconEditor } from "@/assets/icons";
import { RsoIndustryDetailSection } from "@/features/rso/components/rso-detail/RsoIndustryDetailSection";

type TRsoDetailContentProps = {
  data: TGetRSODto;
};

export const RsoDetail: FCC<TRsoDetailContentProps> = ({ data }) => {
  const navigate = useNavigate();

  const tabs = useMemo(() => {
    return [
      {
        title: "irohana visa 連携設定",
        content: <RsoVisaLinkSection data={data} />,
      },
      {
        title: "基本情報",
        content: <RsoBasicInfoSection data={data} />,
      },
      {
        title: "取り扱う分野",
        content: <RsoIndustryDetailSection rsoData={data} />,
      },
      {
        title: "契約情報",
        content: <RsoContractInfoSection data={data} />,
      },
    ];
  }, [data]);

  return (
    <>
      <Stack gap={2}>
        <Typography variant="head20Bold" color={text.primary}>
          登録支援機関情報
        </Typography>
      </Stack>
      <Grid container sx={{ marginTop: 4 }}>
        <Grid item xs={12}>
          <MenuNavigate
            contents={tabs}
            contentAffix={
              <FooterContainer>
                <Stack gap={1} direction="row" justifyContent="flex-end" alignItems="center">
                  <Button variant="outline" onClick={() => navigate(AppRoutes.rsoEdit)} startIcon={<IconEditor />}>
                    編集
                  </Button>
                </Stack>
              </FooterContainer>
            }
            contentWidth="900px"
          />
        </Grid>
      </Grid>
    </>
  );
};
